import { DialogTitle } from '@headlessui/react';
import React, { FunctionComponent, ReactNode } from 'react';
import { classNames } from '../../utils/class-names';
import Modal from './modal';

// react-bootstrap Modal compatible surface (show/onHide + Header/Title/
// Body/Footer) rendered on the Headless UI modal shell.

interface ModalDialogProps {
  show: boolean;
  onHide: () => void;
  centered?: boolean;
  backdrop?: boolean | 'static';
  keyboard?: boolean;
  children?: ReactNode;
}

const ModalDialog: FunctionComponent<ModalDialogProps> & {
  Header: FunctionComponent<{ closeButton?: boolean; children?: ReactNode }>;
  Title: FunctionComponent<{ children?: ReactNode }>;
  Body: FunctionComponent<{ className?: string; children?: ReactNode }>;
  Footer: FunctionComponent<{ children?: ReactNode }>;
} = ({ show, onHide, children }) => (
  <Modal isOpen={show} onClose={() => onHide()}>
    {children}
  </Modal>
);

ModalDialog.Header = ({ children }) => (
  <div className="pb-3 border-b border-gray-200">{children}</div>
);

ModalDialog.Title = ({ children }) => (
  <DialogTitle as="h3" className="text-lg font-medium text-gray-900 m-0 pr-8">
    {children}
  </DialogTitle>
);

ModalDialog.Body = ({ className, children }) => (
  <div className={classNames('py-4', className || '')}>{children}</div>
);

ModalDialog.Footer = ({ children }) => (
  <div className="pt-3 border-t border-gray-200 flex flex-row-reverse gap-2">{children}</div>
);

export default ModalDialog;
